module.exports = __webpack_public_path__ + "static/media/motivation.51941f11.svg";